"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardBadgeArea = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardBadgeAreaMixin = require("../../mixins/components/PropertyCardBadgeAreaMixin");
var StyledPropertyCardBadgeArea = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledPropertyCardBadgeArea",
  componentId: "c11n-8-107-0__sc-11omngf-0"
})(["", ""], _PropertyCardBadgeAreaMixin.PropertyCardBadgeAreaMixin);
exports.StyledPropertyCardBadgeArea = StyledPropertyCardBadgeArea;